/**
 * BulkProtectionBreakdown — MAP-UX-1E.
 *
 * Painel compacto exibido DENTRO dos modais de confirmação crítica de ações em
 * massa (ConfirmCriticalAction e BulkRelayRebootModal). Deixa inequívoco, ANTES
 * de o operador confirmar:
 *   - total selecionado;
 *   - elegíveis (recebem o comando) — verde;
 *   - protegidos de produção (denylist OTA) — NÃO recebem o comando — roxo + 🔒,
 *     consistente com o anel/badge do marcador e o painel (MAP-UX-1C/1D);
 *   - offline entre os elegíveis (comando fica enfileirado até reconectar) —
 *     informativo, NÃO é pulado.
 *
 * Puramente apresentacional. O backend (guard em `enqueue_command` + pré-filtro
 * do bulk-command + denylist) continua sendo a fonte da verdade; este painel só
 * reflete o recorte client-side já calculado a partir de `ota_protected` do DTO
 * do mapa. Não envia comando, não altera seleção, não relaxa nenhum guard.
 */

function Line({ label, value, valueClass = "", dotClass }) {
  return (
    <div className="flex items-center justify-between gap-3">
      <span className="flex items-center gap-1.5 text-noc-muted">
        {dotClass && (
          <span className={`inline-block w-1.5 h-1.5 rounded-full ${dotClass}`} />
        )}
        {label}
      </span>
      <span className={`font-mono ${valueClass}`}>{value}</span>
    </div>
  );
}

export default function BulkProtectionBreakdown({
  total = 0,
  eligible = 0,
  protectedCount = 0,
  protectedIds = [],
  offlineCount = 0,
  actionLabel = "esta ação",
}) {
  if (!total) return null;
  const shown = (protectedIds || []).slice(0, 8);
  const extra = Math.max(0, protectedCount - shown.length);
  const plural = protectedCount !== 1;

  return (
    <div className="rounded-lg border border-noc-border/60 bg-noc-bg/40 px-3 py-2 space-y-1 text-xs">
      <Line label="Total selecionado" value={total} valueClass="text-noc-text font-semibold" />
      <Line
        label="Elegíveis (recebem)"
        value={eligible}
        valueClass="text-noc-ok font-semibold"
        dotClass="bg-noc-ok"
      />
      {protectedCount > 0 && (
        <>
          <Line
            label={<span className="text-noc-purple">🔒 Protegidos (produção)</span>}
            value={protectedCount}
            valueClass="text-noc-purple font-semibold"
          />
          {shown.length > 0 && (
            <div className="text-[10px] text-noc-purple/80 font-mono break-all pl-0.5">
              {shown.join(", ")}{extra > 0 ? ` … +${extra}` : ""}
            </div>
          )}
        </>
      )}
      {offlineCount > 0 && (
        <Line
          label="Offline (fica enfileirado)"
          value={offlineCount}
          valueClass="text-noc-muted"
          dotClass="bg-noc-muted"
        />
      )}
      {protectedCount > 0 && (
        <div className="text-[11px] text-noc-purple/90 pt-1 mt-1 border-t border-noc-border/40">
          ⚠ {protectedCount} dispositivo{plural ? "s" : ""} de produção protegida
          {" "}NÃO receberá{plural ? "ão" : ""} {actionLabel} — bloqueado pelo
          backend (denylist de produção).
        </div>
      )}
    </div>
  );
}
